var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.69107 4.1689L1.30795 8.24338C1.06402 8.47014 1.06402 8.83893 1.30795 9.06568L5.69107 13.1402C5.93332 13.3654 6.32479 13.3654 6.56705 13.1402C6.81098 12.9134 6.81098 12.5446 6.56705 12.3179L3.20289 9.19059H16.3125L16.4136 9.18226C16.676 9.13847 16.875 8.92731 16.875 8.67342C16.875 8.38779 16.6232 8.15625 16.3125 8.15625H3.15853L6.56705 4.9912C6.81098 4.76444 6.81098 4.39566 6.56705 4.1689C6.32479 3.9437 5.93332 3.9437 5.69107 4.1689Z",
    fill: "#1B8C96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowIcon);
export default __webpack_public_path__ + "static/media/back-arrow-icon.1b1b8b3df89709e7434fce41fede771b.svg";
export { ForwardRef as ReactComponent };